// TODO check updateTheme updateNavigation updateLanguage and refactor this file
import { Button, Form, Icon, Input, Title } from '@fnacdarty/back-office-ui';
import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { useTheme } from 'styled-components';
import { useLocation } from 'react-router-dom';
import {
	StyledContainer,
	StyledTitleContainer,
	StyledError,
	StyledBlock,
	StyledModifyPassword,
	StyledSuccess,
	StyledText,
	StyledGoBack,
} from './index.styled';
import {
	authenticateUser,
	callResetLink,
	handleAuth,
	isLoggedIn,
} from '../../utils/auth';
import { useForm } from '../../../../hooks';
import { BrandHeadBar, FooterBar } from '../../../../layouts';
import microsoftLogo from '../../../../assets/images/logos/microsoft.svg';
import TwoFactorLogin from '../TwoFactorLogin';

const LoginForm = () => {
	const theme = useTheme();

	const [status, setStatus] = useState({
		loading: false,
		error: '',
	});

	const [showPassword, isPasswordShow] = useState(false);
	const [passwordLost, isPasswordLost] = useState(false);
	const [linkSent, setLinkSent] = useState(false);
	const [resetMailValue, setResetMailValue] = useState('');
	const { formData, handleOnChange } = useForm({
		username: '',
		password: '',
		resetMail: '',
	});
	const handleEmailChange = (event) => {
		setResetMailValue(event.target.value);
		handleOnChange(event);
		setLinkSent(false);
		setStatus({
			...status,
			error: '',
			loading: false,
		});
	};
	const [doubleAuth, setDoubleAuth] = useState({
		mfaToken: '',
		isActive: false,
	});

	const togglePassword = () => {
		isPasswordShow(!showPassword);
	};

	const toggleLostPassword = () => {
		setLinkSent(false);
		isPasswordLost(!passwordLost);
		setStatus({
			...status,
			error: '',
			loading: false,
		});
		setResetMailValue('');
	};

	const extraActionLogin = async (token, refreshToken, user) => {
		const loggedInAt = new Date();
		handleAuth({
			...user,
			token,
			refreshToken,
			loggedInAt,
		});
		setStatus({
			...status,
			loading: false,
		});
		return true;
	};

	const handleFormSubmit = async (event) => {
		event.preventDefault();

		if (passwordLost) {
			const payload = {
				mailAddress: formData.resetMail,
			};

			const validateInternalEmail = (email) => email.indexOf('darty');

			const validateEmailFormat = (email) => {
				const emailReg =
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/i;
				return emailReg.test(email);
			};

			if (!validateEmailFormat(payload.mailAddress)) {
				const message =
					"Le format de l'adresse e-mail n'est pas valide !";
				return setStatus({
					...status,
					error: message,
					loading: false,
				});
			}

			const mailSpilted = payload.mailAddress.split('@');
			const domaine = mailSpilted[1];
			if (validateInternalEmail(domaine) !== -1) {
				const message =
					'Pour les utilisateurs internes, veuillez contacter le SVP !';
				return setStatus({
					...status,
					error: message,
					loading: false,
				});
			}

			const res = await callResetLink(payload);

			if (res.success) {
				setLinkSent(true);
				setStatus({
					...status,
					error: '',
					loading: false,
				});
				return true;
			}

			return setStatus({
				...status,
				error: res.message,
				loading: false,
			});
		}
		const payload = {
			username: formData.username,
			password: formData.password,
		};

		const res = await authenticateUser(payload);

		if (res.success) {
			if (res?.data?.mfa) {
				setDoubleAuth({
					mfaToken: res?.data?.mfa.token,
					isActive: true,
				});
				setStatus({
					...status,
					loading: false,
				});
				return true;
			}
			const { user, token, refreshToken } = res.data;
			if (extraActionLogin(token, refreshToken, user)) {
				return true;
			}
			return false;
		}

		setStatus({
			...status,
			error: res.message,
			loading: false,
		});
		return null;
	};

	const closeTwoFactorMode = () => {
		setDoubleAuth({
			mfaToken: '',
			isActive: false,
		});
	};

	const location = useLocation();
	const navigate = useNavigate();
	if (isLoggedIn()) {
		const { state } = location;
		const redirectURL = state ? state.from : '/';
		return navigate(redirectURL);
	}

	return (
		<>
			{doubleAuth.isActive ? (
				<TwoFactorLogin
					closeMode={closeTwoFactorMode}
					mfaToken={doubleAuth.mfaToken}
					extraActionLogin={extraActionLogin}
				/>
			) : (
				<>
					<BrandHeadBar />
					<StyledContainer>
						{!passwordLost ? (
							<>
								<StyledTitleContainer>
									<Title level={2}>Connexion</Title>
								</StyledTitleContainer>
								<Form onSubmit={handleFormSubmit}>
									<StyledBlock>
										<Input
											name="username"
											type="text"
											placeholder="joh1doe"
											required
											label="login"
											value={formData.username}
											onChange={handleOnChange}
										/>
										<span
											style={{
												position: 'absolute',
												right: '40px',
												top: '14px',
											}}
										>
											<Icon
												name="users"
												width={24}
												style={{
													position: 'absolute',
													float: 'right',
												}}
												color={theme.colors.muted}
											/>
										</span>
									</StyledBlock>
									<StyledBlock>
										<Input
											name="password"
											type={
												showPassword
													? 'text'
													: 'password'
											}
											placeholder="••••••••••"
											required
											label="Password"
											value={formData.password}
											onChange={handleOnChange}
										/>
										<span
											style={{
												position: 'absolute',
												right: '40px',
												top: '14px',
											}}
										>
											<Icon
												name="eye"
												width={24}
												style={{
													position: 'absolute',
													float: 'right',
												}}
												onClick={togglePassword}
												color={
													showPassword
														? theme.colors.primary
														: theme.colors.muted
												}
											/>
										</span>
									</StyledBlock>
									<StyledModifyPassword
										onClick={toggleLostPassword}
									>
										Mot de passe oublié ?
									</StyledModifyPassword>
									<Button
										type="submit"
										style={{
											backgroundColor:
												theme.colors.portail,
										}}
									>
										{status.loading
											? 'Chargement...'
											: 'Se connecter'}
									</Button>
								</Form>
								<span
									style={{
										marginTop: '20px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									{/* ou */}
								</span>
								<Button
									style={{
										backgroundColor:
											theme.colors.primaryLight,
										marginTop: '10px',
									}}
									onClick={() => {
										window.location.href =
											process.env.REACT_APP_SSO_ENDPOINT;
									}}
								>
									<img
										src={microsoftLogo}
										alt={'microsoft-logo'}
										width={26}
										style={{
											height: 'auto',
											marginRight: '20px',
										}}
									/>
									Se connecter avec Office 365
								</Button>
							</>
						) : (
							<>
								<StyledTitleContainer>
									<Title level={2}>
										Mot de passe oublié ?
									</Title>
								</StyledTitleContainer>
								<StyledText>
									Indiquez l&apos;adresse e-mail associée à
									votre compte Darty pour réinitialiser votre
									mot de passe
								</StyledText>

								<Form onSubmit={handleFormSubmit}>
									<StyledBlock>
										<Input
											name="resetMail"
											type="text"
											required
											label="mail"
											value={resetMailValue}
											onChange={handleEmailChange}
										/>
										<span
											style={{
												position: 'absolute',
												right: '40px',
												top: '14px',
											}}
										>
											<Icon
												name="mail"
												width={24}
												style={{
													position: 'absolute',
													float: 'right',
												}}
												color={theme.colors.muted}
											/>
										</span>
									</StyledBlock>
									<Button
										type="submit"
										style={{
											backgroundColor:
												theme.colors.portail,
										}}
									>
										Réinitialiser
									</Button>

									{linkSent ? (
										<>
											<StyledSuccess className="succes">
												Si le compte existe, un lien de
												réinitialisation vous sera
												envoyé par e-mail.
											</StyledSuccess>
											<StyledSuccess className="succes"></StyledSuccess>
										</>
									) : null}
								</Form>
							</>
						)}
						{status.error ? (
							<StyledError className="error">
								{status.error}
							</StyledError>
						) : null}
						{passwordLost ? (
							<>
								<StyledGoBack onClick={toggleLostPassword}>
									Retour
								</StyledGoBack>
							</>
						) : null}
						<span
							style={{
								marginTop: '20px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<FooterBar />
						</span>
					</StyledContainer>
				</>
			)}
		</>
	);
};

export default LoginForm;
